<template>
  <div
    class="anz-post-tooltip anz-bg-black-3 anz-py-l anz-px-xl anz-mt-m anz-b-all anz-b-rounded"
  >
    <div class="anz-flex anz-align-items-start anz-mb-s">
      <h6
        class="anz-fs-xs anz-text-uppercase anz-flex anz-align-items-center anz-flex-wrap"
      >
        <a-icon
          width="1em"
          height="1.1428em"
          name="map-navigation"
          class-name="anz-mr-s"
        />
        {{ $translate('post.texts.bannedTooltipHeader') }}
      </h6>
      <a-button
        class="anz-btn-close anz-ml-auto anz-mtn-xxs anz-mrn-s"
        @click="$emit('tooltip-close')"
        show-icon
        icon-width="0.7142em"
        icon-height="0.7142em"
        icon-name="cross-solid"
      />
    </div>
    <div class="anz-flex-sm anz-align-items-start">
      <div class="anz-mr-s">
        {{ $translate('post.texts.banned') }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { TOOLTIP_COMPONENTS } from '@/composables/post/postTooltip'
import AButton from '@/components/Forms/AButton.vue'
import AIcon from '@/components/AIcon.vue'

export default defineComponent({
  name: TOOLTIP_COMPONENTS.POST_BANNED,
  emits: ['tooltip-close'],
  components: { AIcon, AButton },
  props: {
    alreadyPerformed: {
      type: Boolean,
      default: false,
    },
  },
})
</script>
